import styled from 'styled-components';
import { fontSize, fontWeight, mediaMax, primaryColor, tertiaryColor } from '@styles/utils';
import { Button } from '@styles/shared/buttons';
import FormField from '@shared/modules/form/components/FormField';

export const TicketCreateContainer = styled.div`
  padding: 40px 0;
  margin: 0 auto;
  width: 100%;
  max-width: 1090px;

  @media screen and (max-width: 1230px) {
    padding: 40px 16px;
  }

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const TicketCreateTitle = styled.h2`
  ${fontSize.h2};
  font-weight: ${fontWeight.standard};
  color: ${primaryColor(500)};
`;

export const TicketCreateText = styled.p`
  padding-top: 24px;
  ${fontSize.standard};
  font-weight: ${fontWeight.normal};
  color: ${tertiaryColor(700)};
`;

export const TicketCreateFormContainer = styled.form`
  padding-top: 16px;
`;

export const TicketCreateDoubleInput = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media screen and (max-width: 1230px) {
    grid-template-columns: 1fr;

    &:not(:first-child) {
      padding-top: 20px;
    }
  }
`;

export const TicketCreateCommentContainer = styled(FormField)`
  position: relative;
  padding-top: 16px;
`;

export const TicketCreateCommentRemaining = styled.p`
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(calc(100% + 5px));
  ${fontSize.extraSmall};
  font-style: italic;
  color: ${tertiaryColor(400)};
`;

export const TicketCreateRequired = styled.p`
  padding-top: 32px;
  ${fontSize.small};
  color: ${tertiaryColor(400)};
`;

export const TicketCreateActions = styled.div`
  padding-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TicketCreateButton = styled(Button)`
  width: max-content;
`;
